import { render, staticRenderFns } from "./NewInputEmail.vue?vue&type=template&id=065b6d44&scoped=true&"
import script from "./NewInputEmail.vue?vue&type=script&lang=js&"
export * from "./NewInputEmail.vue?vue&type=script&lang=js&"
import style0 from "./NewInputEmail.vue?vue&type=style&index=0&id=065b6d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b6d44",
  null
  
)

export default component.exports